// ExploreGraph — the FULL CCPD Agate explorer, embedded in the console.
// Renders CCPD's own /explore surface (served by the CCPD container, fronted by
// Caddy on :8544 of the console FQDN) inside an iframe, so clicking the nav item
// shows exactly what you'd get going straight to CCPD's URL — no new tab.
//
// Caddy on :8544 has X-Frame-Options stripped and CSP frame-ancestors widened to
// this console origin so the frame is allowed; basic-auth on :8544 is dropped for
// now (SG-scoped to demo IPs; the embed lives inside the login-gated console).
// WorkOS SSO will re-gate it later.
export default function ExploreGraph() {
  // ?embed=1 puts agate in chromeless mode (no CCPD sidebar/header) so only the
  // graph renders inside the console pane. See agate App.tsx / MainLayout.
  const src = `https://${window.location.hostname}:8544/explore?embed=1`;
  // Fill the content area: AppShell's main layout is 100vh and PageContainer adds
  // 36px vertical padding (12 top + 24 bottom). h-full/flex won't resolve against
  // the flex-sized Content, so size the iframe to the viewport directly.
  return (
    <iframe
      src={src}
      title="CCPD Graph Explorer"
      style={{ width: "100%", height: "calc(100vh - 36px)", border: "none", display: "block" }}
      allow="clipboard-read; clipboard-write"
    />
  );
}
